const PATHS = {
  HOME: "/",
  CASE_STUDY: "/case-study",
  ENVIROMENTS: "/environment",
  CONSOLE: "/console",
};

export default PATHS;
